<template>
  <div class="login_content">
    <van-nav-bar
      left-text="返回"
      @click="$router.go(-1)"
      left-arrow
      title="注册"
    />

    <van-form @submit="Login">
      <div class="uploadHeads">
        <van-uploader v-model="HeadSculptureList" multiple :max-count="1" />
      </div>
      <van-cell-group inset>
        <van-field
          v-model="AccountModel.Name"
          name="姓"
          label="姓"
          placeholder="姓"
        />
        <van-field
          v-model="AccountModel.LastName"
          name="名"
          label="名"
          placeholder="名"
        />
        <van-field
          v-model="AccountModel.Account"
          name="用户名"
          label="用户名"
          placeholder="用户名"
        />
        <van-field
          v-model="AccountModel.Phone"
          name="手机号"
          label="手机号"
          placeholder="手机号"
        />
        <van-field
          v-model="AccountModel.Email"
          name="邮箱"
          label="邮箱"
          placeholder="邮箱"
        />
        <van-field
          v-model="AccountModel.Code"
          center
          clearable
          label="验证码"
          placeholder="请输入验证码"
        >
          <template #button>
            <van-button size="small" @click="ValidateEmail" type="primary"
              >发送验证码</van-button
            >
          </template>
        </van-field>
        <van-field
          v-model="AccountModel.Password"
          type="password"
          name="密码"
          label="密码"
          placeholder="密码"
        />
        <van-field
          v-model="AccountModel.ConfirmPassword"
          type="password"
          name="密码"
          label="密码"
          placeholder="确认密码"
        />
      </van-cell-group>

      <div style="margin: 16px">
        <p>
          <router-link to="register" />
        </p>
        <van-button
          @click="Register"
          round
          block
          type="primary"
          native-type="submit"
        >
          注册
        </van-button>
      </div>
    </van-form>
  </div>
</template>

<script >
import axios from "../../commons/AxiosMethod.js"
import { showToast } from "vant"
export default {
  data () {
    return {
      clientWidth: document.body.clientWidth,
      clientHeight: document.documentElement.clientHeight,

      HeadSculptureList: [], // 头像列表
      AccountModel: {} // 注册信息
    }
  },
  name: "App",

  components: {},
  mounted () {
    this.GetProvinceCityCategoryTree()
  },
  methods: {

    // 提交注册
    Register () {
      const param = {}
      axios.apiMethod(
        "/api/User/Register",
        "post",
        this.AccountModel,
        (result) => {
          if (result.Code == 200) {
            if (result.Data.Success) {
              showToast({
                type: "html",
                message: "注册成功"
              })
              axios.ToLogin()
            } else {
              var html = ""
              result.Data.Msg.forEach((e) => {
                html += "<p>" + e + "</p>"
              })
              showToast({
                type: "html",
                message: html
              })
            }
          }
        }
      )
    },
    // 获取vant格式
    GetProvinceCityCategoryTree () {
      var param = {}
      axios.apiMethod(
        "/api/SystemConfiguration/GetProvinceCityCategoryTree",
        "get",
        param,
        (result) => {
          if (result.Code == 200) {
            this.addressOptions = result.Data
          }
        }
      )
    },
    // 验证邮箱
    ValidateEmail () {
      const param = {}
      axios.apiMethod(
        "/api/User/SendEmailCode",
        "post",
        this.AccountModel,
        (result) => {
          if (result.Code == 200) {
            if (result.Data.Success) {
              ElMessage({
                title: "提示",
                message: "验证码已发送",
                type: "success"
              })
            } else {
              ElMessage({
                title: "提示",
                message: result.Data.Msg
              })
            }
          } else {
            ElMessageBox({
              message: result.FullMsg,
              type: "error"
            })
          }
        }
      )
    }
  }
}
</script>

<style lang="less" scoped>
.uploadHeads {
  width: 100%;
  text-align: center;
  margin-top: 40px;
}
</style>
